
import _ from 'lodash';
import $ from 'jquery';

let intersectionObserver;
let intersectionCallback;

/**
 * bind image element to observe in lazy load
 * @param {*} observeElements need lazy load elements
 */
export const intLazyLoadImg = (observeElements, afterOnLoad) => {
    intersectionCallback = afterOnLoad;
    if (!intersectionObserver) {
        intersectionObserver = new IntersectionObserver(function(entries) {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            _.forEach(entries, ((entry) => {
                if (entry.intersectionRatio <= 0 || !entry.isIntersecting) return;

                const target = _.get(entry, 'target');
                if (target) {
                    const $target = $(target);
                    $target.attr('src', $target.attr('data-src'))
                        .on('load', () => {
                            $target.css({ width: $target.attr('data-width') })
                                .removeAttr('data-src')
                                .removeAttr('data-width')
                                .removeClass('img-loading');
                            if ($target.attr('data-max-width')) {
                                $target.css({ 'max-width': $target.attr('data-max-width') });
                                $target.removeAttr('data-max-width');
                            }
                            intersectionCallback && intersectionCallback();
                        });
                    intersectionObserver.unobserve(target);
                }
            }));
        });
    }
    // start observing
    if (observeElements) {
        if (observeElements.length) {
            _.forEach(observeElements, v => {
                intersectionObserver.observe(v);
            });
        } else {
            intersectionObserver.observe(observeElements);
        }
    }
};
